// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__XPEOO","innerContainer":"Main_innerContainer__zFBH4","heading":"Main_heading__1p3jU","description":"Main_description__BfiVY"};